import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const DEFAULT_VIEWBOX = "0 0 11 14";
const NextPageIcon = ({ size, viewBox = DEFAULT_VIEWBOX, ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, viewBox, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M0 1.82236V12.1794C0 12.9684 0.871 13.4464 1.537 13.0234L9.674 7.84536C10.292 7.45236 10.292 6.55136 9.674 6.15836L1.537 0.978357C0.871 0.554357 0 1.03336 0 1.82236Z",
      fill: rest.fill
    }
  ) });
};
export {
  NextPageIcon
};
